export default __webpack_public_path__ + "static/favicon-b4634569afabeb1a57a8b3854b68e58f.png";